const CACHE_KEY = "galleryCache";

const isCacheValid = (timestamp) => {
  const now = new Date();
  const cacheDate = new Date(timestamp);

  const nextMonday = new Date(now);
  nextMonday.setDate(now.getDate() + ((1 + 7 - now.getDay()) % 7 || 7));
  nextMonday.setHours(0, 0, 0, 0);

  const lastMonday = new Date(now);
  const daysToLastMonday = now.getDay() - 1;
  lastMonday.setDate(
    now.getDate() - (daysToLastMonday >= 0 ? daysToLastMonday : 6)
  );
  lastMonday.setHours(0, 0, 0, 0);

  const timeUntilGeneration = nextMonday.getTime() - now.getTime();
  const fiveMinutes = 5 * 60 * 1000;

  return cacheDate > lastMonday && timeUntilGeneration > fiveMinutes;
};

export const getDate = (url) => {
  const filename = url.split("/").pop();
  const timestamp = parseInt(filename.match(/\d+/)[0], 10);
  const date = new Date(timestamp);

  return date.toLocaleDateString("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export async function getImageList() {
  const cache = localStorage.getItem(CACHE_KEY);

  if (cache) {
    const { timestamp, data } = JSON.parse(cache);

    if (isCacheValid(timestamp) && data?.images?.length) {
      return data.images;
    }
  }

  const urlRes = await fetch("/api/get-image-list-url");
  const { url: jsonUrl } = await urlRes.json();
  const dataRes = await fetch(`${jsonUrl}?t=${Date.now()}`, {
    cache: "no-store",
  });
  const images = await dataRes.json();

  if (images?.length) {
    localStorage.setItem(
      CACHE_KEY,
      JSON.stringify({
        timestamp: Date.now(),
        data: { images },
      })
    );
  }

  return images;
}
